export const VOICE_BITRATE = 128;
export const VOICE_SAMPLERATE = 48000;
export const VOICE_SAMPLES_COUNT = 1152;
export const VOICE_CHANNELS_COUNT = 1;

export const VOICE_DURATION_MIN = 0.5;
